import { createReducer } from '@common/redux-utils';
import {
  DispatchActionType,
  SearchDispatchListStartAction,
  SearchDispatchListSuccessAction,
  SearchDispatchListFailureAction,
  GetStatusCountStartAction,
  GetStatusCountSuccessAction,
  GetStatusCountFailureAction,
  SWOOwnershipStartAction,
  SWOOwnershipSuccessAction,
  SWOOwnershipFailureAction
} from './dispatch.actions';
import { StatusCountViewModel, ServiceWorkOrderSearchViewModel } from '@models/ServiceWorkOrder';
export interface DispatchState {
  readonly dispatchList: Array<ServiceWorkOrderSearchViewModel>;
  readonly query: string | null;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly pageCount: number;
  readonly orderBy: string;
  readonly message: string;
  readonly loading?: boolean;
  readonly statusCount: StatusCountViewModel;
}

export const initialDispatchState: DispatchState = {
  dispatchList: [] as Array<ServiceWorkOrderSearchViewModel>,
  query: '',
  pageNumber: 0,
  pageSize: 10,
  pageCount: 10,
  orderBy: '',
  message: '',
  statusCount: {} as StatusCountViewModel
};
/***** Search Dispatch List ****/
function handleSearchDispatchListStart(state: DispatchState, action: SearchDispatchListStartAction): DispatchState {
  return {
    ...state,
    query: action.query,
    loading: true
  };
}

function handleSearchDispatchListSuccess(state: DispatchState, action: SearchDispatchListSuccessAction): DispatchState {
  return {
    ...state,
    pageNumber: action.pageNumber,
    pageSize: action.result.pageSize,
    pageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    dispatchList: action.result.results,
    orderBy: action.orderBy,
    loading: false
  };
}
function handleSearchDispatchListFailure(state: DispatchState, action: SearchDispatchListFailureAction): DispatchState {
  return {
    ...state,
    message: action.error,
    loading: false
  };
}

/***** Get Status Count *****/

function handleGetStatusCountStart(state: DispatchState, action: GetStatusCountStartAction): DispatchState {
  return {
    ...state
  };
}

function handleGetStatusCountSuccess(state: DispatchState, action: GetStatusCountSuccessAction): DispatchState {
  return {
    ...state,
    statusCount: action.statusCount
  };
}

function handleGetStatusCountFailure(state: DispatchState, action: GetStatusCountFailureAction): DispatchState {
  return {
    ...state
  };
}

/****** SWO Ownership ******/
function handleSWOOwnershipStart(state: DispatchState, action: SWOOwnershipStartAction): DispatchState {
  return {
    ...state,
    loading: true
  };
}

function handleSWOOwnershipSuccess(state: DispatchState, action: SWOOwnershipSuccessAction): DispatchState {
  const newDispatchList = state.dispatchList.filter(x => x.id !== action.swo.id).concat([action.swo]);

  return {
    ...state,
    dispatchList: newDispatchList
  };
}

function handleSWOOwnershipFailure(state: DispatchState, action: SWOOwnershipFailureAction): DispatchState {
  return {
    ...state
  };
}

export const DispatchReducer = createReducer<DispatchState, DispatchActionType>(initialDispatchState, {
  [DispatchActionType.SearchDispatchListStart]: handleSearchDispatchListStart,
  [DispatchActionType.SearchDispatchListSuccess]: handleSearchDispatchListSuccess,
  [DispatchActionType.SearchDispatchListFailure]: handleSearchDispatchListFailure,

  [DispatchActionType.GetStatusCountStart]: handleGetStatusCountStart,
  [DispatchActionType.GetStatusCountSuccess]: handleGetStatusCountSuccess,
  [DispatchActionType.GetStatusCountFailure]: handleGetStatusCountFailure,

  [DispatchActionType.SWOOwnershipStart]: handleSWOOwnershipStart,
  [DispatchActionType.SWOOwnershipSuccess]: handleSWOOwnershipSuccess,
  [DispatchActionType.SWOOwnershipFailure]: handleSWOOwnershipFailure
});



// WEBPACK FOOTER //
// ./src/service-work-order/dispatch/dispatch.reducer.tsx